import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Text, Button } from "@fragments";
import { AddLinkRounded } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";

import LinkInfo from "./LinkInfo";

const MAX_LINKS = 3;

export default function DescriptionLinks({
    configRef,
    errors = {},
    clearError = () => {},
}) {
    const { t } = useTranslation("groupModals");
    const [links, setLinks] = useState(configRef.current.links || []);

    function handleAdd() {
        const next = [...links, { title: "", url: "", open: true }];
        configRef.current.links = next;
        setLinks(next);
    }

    function handleRemove(index) {
        const next = [...links];
        next.splice(index, 1);
        configRef.current.links = next;
        setLinks(next);
        clearError(`links.${index}`);
    }

    function handlePatch(index, patch) {
        const arr = configRef.current.links;
        arr[index] = { ...arr[index], ...patch };
        if (patch.title !== undefined) clearError(`links.${index}.title`);
        if (patch.url !== undefined) clearError(`links.${index}.url`);
    }

    return (
        <div className="pb-2">
            <Text.h3
                left={<AddLinkRounded />}
                value={t("manageGroup.links.title")}
                className="mt-5 mb-2"
                grow
                right={
                    <Button
                        color="overlay"
                        variant="dashed"
                        onClick={handleAdd}
                        size="small"
                        disabled={links?.length >= MAX_LINKS}
                        endIcon={<AddIcon />}
                        text={t("manageGroup.links.add")}
                    />
                }
            />

            {links?.map((link, i) => (
                <LinkInfo
                    key={i}
                    data={link}
                    errors={errors?.links?.[i]}
                    onPatch={(patch) => handlePatch(i, patch)}
                    onRemove={() => handleRemove(i)}
                />
            ))}
        </div>
    );
}
